<template>
    <div class="modal fade" id="init_feedback_app" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="init_feedback_app_modalLabel">Initialize Feedback For Branch: {{branchFeedback.branch.areasByAreaId.name}}</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>
                                    <input type="checkbox" v-model="branchFeedback.takeCustomerInfo"/> Take Customer Information
                                </label>
                            </div>
                            <h3>Questions</h3>
                            <hr/>
                            <div class="row" v-for="(question,index) in branchFeedback.questions" :key="'feedback_quest_' + index" style="margin-bottom: 10px">
                                <div class="col-md-6"><input type="text" class="form-control"  v-model="question.question" placeholder="Question Goes Here..." /></div>
                                <div class="col-md-3">
                                    <select v-model="question.type" class="form-control">
                                        <option value="emoticon">Emoticon</option>
                                        <option value="text">Text Field</option>
                                        <option value="comment">Comment</option>
                                        <option value="radio">Radio Button</option>
                                        <option value="checkboxes">Check Box</option>
                                    </select>
                                </div>
                                <div class="col-md-2">
                                    <input type="number" min="0" v-model="question.priority" placeholder="Priority" class="form-control" />
                                </div>
                                <div class="col-md-1">
                                    <button class="btn btn-danger btn-md" @click="removeQuestion(index)"><i class="fa fa-times"></i></button>
                                </div>
                                <div v-if="question.type === 'radio' || question.type === 'checkboxes'" class="row">
                                    <div class="col-md-6">
                                        <div class="col-md-offset-1"><h4>Add Options</h4><input type="text" class="form-control"  v-model="question.options" placeholder="Enter multiple options separated with comma e.g. A, B" /></div>
                                    </div>
                                </div>
                            </div>
                            <br/>
                            <div class="row">
                                <div class="col-md-12">
                                    <button class="btn btn-info btn-sm pull-left" @click="addNewQuestion()">Add New Question</button>
                                    <button class="btn btn-primary btn-sm pull-right" @click="submitInitialization()">Initialize</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InitializeFeedbackForBranch",
        data() {
          return {
              resName: "",
              resId: "",
              branchFeedback: {
                  id:"",
                  takeCustomerInfo: true,
                  questions: [
                      {question: "", type: "emoticon", priority: 1, options:""}
                  ],
                  branch: {
                      areasByAreaId: {name: ""}
                  },
                  enable: true
              }
          }
        },
        methods: {
             load(resId, resName, branchId) {
                this.resetBranchFeedback();
                this.resName = resName;
                this.resId = resId;
                if(branchId > 0){
                    let params = new URLSearchParams();
                    params.append("branch_id", branchId);
                    this.$http.post(this.$store.state.mainAppURL + "restaurants/get_branch_by_id", params).then(async resp => {
                        const resp2 = await this.$http.get(this.$store.state.mainAppURL + "feedback/config/" + resp.data.id);
                        console.log(resp2.data.id);
                        if(resp2.data !== ""){
                            this.branchFeedback.id= resp2.data.id;
                            this.branchFeedback.branch= resp2.data.branch;
                            this.branchFeedback.questions = resp2.data.feedbackQuestions;
                            this.branchFeedback.takeCustomerInfo= resp2.data.takeCustomerInfo;
                            this.branchFeedback.branch = resp.data;
                            console.log(resp2.data.feedbackQuestions);
                            // this.branchFeedback.questions = JSON.parse(this.branchFeedback.questions);
                            console.log(this.branchFeedback);
                        }else{
                            this.branchFeedback.branch = resp.data;
                        }
                        $("#init_feedback_app").modal('show');
                    });
                }

            },
            addNewQuestion() {
                let newQuestion = {
                    question: "",
                    type: "emoticon",
                    options:""
                };
                this.branchFeedback.questions.push(newQuestion);
            },
            removeQuestion(index) {
                if(this.branchFeedback.questions.length === 1) {
                    swal('Error', 'Feedback need at least one question', 'error');
                    return false;
                }
                this.branchFeedback.questions.splice(index, 1);
            },
            submitInitialization() {
                for(let question of this.branchFeedback.questions){
                    if(question.question === ""){
                        swal('Error', 'Empty Question(s) is not allowed! Please review again', 'error');
                        return false;
                    }
                }
                $("#init_feedback_app").modal('hide');
                swal({
                    title: 'Saving...',
                    onBeforeOpen: () => {
                        swal.showLoading()
                    }
                });
                for(let i in this.branchFeedback.questions){
                    if(!Array.isArray(this.branchFeedback.questions[i].options)){
                         this.branchFeedback.questions[i].options= this.branchFeedback.questions[i].options.split(",");
                    }
                }
                this.branchFeedback.questions.sort(function (a, b) {
                    return a.priority - b.priority;
                    });
                this.branchFeedback.questions = JSON.stringify(this.branchFeedback.questions);
                this.$http.post(this.$store.state.mainAppURL + 'feedback/config/', this.branchFeedback).then(resp => {
                    swal(resp.data.status, resp.data.message, (resp.data.status === 'SUCCESS') ? 'success' : 'error');
                    this.resetBranchFeedback();
                }).catch(e => {
                    console.log(e);
                })
            },
            resetBranchFeedback(){
                this.branchFeedback = {
                        takeCustomerInfo: true,
                        questions: [
                            {question: "", type: "emoticon", options: ""}
                        ],
                        branch: {
                            areasByAreaId: {name: ""}
                        },
                        enable: true
                    }
            }
        },
    }
</script>

<style scoped>

</style>
